import { ReactComponent as PlayIcon } from '../../../../assets/Icons/adornments/Play-Solid.svg';

export default function DetailsHeader({
    header,
}: {
    header: {
        dag_id: string,
        run: string,
        task_id?: string,
        map_index?: number,
    }
}) {
    return (
        <div className="w-full flex justify-between items-center gap-4 pb-2 border-b border-outline">
            <div className="flex justify-start items-end gap-2">
                <div className="flex flex-col justify-start items-start gap-1">
                    <p className="text-[14px] font-semibold text-disable">DAG</p>
                    <p className="text-default font-semibold">{header.dag_id}</p>
                </div>

                <p className='text-disable font-semibold'>/</p>

                <div className="flex flex-col justify-start items-start gap-1">
                    <p className="text-[14px] font-semibold text-disable">Run</p>
                    <div className='flex justify-start items-center gap-1'>
                        <div className='w-[12px] text-default'><PlayIcon /></div>
                        <p className="text-default font-semibold">{header.run}</p>
                    </div>
                </div>

                {header.task_id && (
                    <>
                        <p className='text-disable font-semibold'>/</p>
                        <div className="flex flex-col justify-start items-start gap-1">
                            <p className="text-[14px] font-semibold text-disable">Task</p>
                            <p className="text-default font-semibold">{header.task_id}</p>
                        </div>
                    </>
                )}

                {header.map_index !== undefined && (
                    <>
                        <p className='text-disable font-semibold'>/</p>
                        <div className="flex flex-col justify-start items-start gap-1">
                            <p className="text-[14px] font-semibold text-disable">Map Index</p>
                            <p className="text-default font-semibold">{header.map_index}</p>
                        </div>
                    </>
                )}
                
            </div>
            <div></div>
        </div>
    )
}